module.exports = __webpack_public_path__ + "img/bw.f2fa747b.png";